class SyncedInputs {
    constructor(element) {
        this.syncId = element.getAttribute("data-sync-input");
        this.parentInput = document.getElementById(this.syncId);
        this.initialData = this.parentInput.value ?? "";
        this.syncedInputs = document.querySelectorAll(
            `#${this.syncId}, [data-sync-input="${this.syncId}"]`,
        );

        // A flag to prevent loops
        this.isUpdating = false;

        this.syncedInputs.forEach((input) => {
            input.addEventListener("input", (event) => this.handleInput(event));
        });

        this.data = new Proxy(
            {},
            {
                set: (obj, key, value) => {
                    obj[key] = value;

                    this.updateInputs(key, value);

                    return true;
                },
            },
        );
    }

    updateInputs(key, value) {
        this.isUpdating = true;
        for (let input of this.syncedInputs) {
            input.value = value;

            input.dispatchEvent(new Event("input"));
        }
        this.isUpdating = false;
    }

    handleInput(event) {
        // Ignore events triggered by programmatic updates
        if (this.isUpdating) {
            return;
        }

        if (!Array.from(this.syncedInputs).includes(event.target)) {
            return;
        }

        this.data[event.target.name] = event.target.value;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-sync-input]").forEach((element) => {
        new SyncedInputs(element);
    });
});
